export default {
  title: 'Usuarios',
  UsersView: {
    deleteTitle: 'Listado de usuarios para eliminar',
    success: 'Los usuarios fueron eliminados con éxito.'
  },
  user: {
    new: 'Nuevo usuario',
    data: 'Introduzca los datos del nuevo usuario',
    add: 'Añadir usuario',
    changePass: 'Modificar contraseña'
  },
  table: {
    saveNew: 'Guardar como nuevo elemento',
    createAndSelect: 'Crear y seleccionar',
    updateAndSelect: 'Actualizar y seleccionar',
    undo: 'Deshacer cambios',
    select: 'Seleccionar',
    noResults: 'No se encontraron resultados',
    username: 'Usuario',
    userRole: 'Rol',
    email: 'email',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado'
  },
  searchUser: {
    title: 'Agenda',
    search: 'Buscar en usuarios',
    showing: 'Mostrando',
    username: 'Usuario',
    userRole: 'Rol',
    email: 'Email',
    more: 'Ver más',
    addSelected: 'Añadir seleccionado',
    allContacts: 'Todos los contactos',
    deleteTitle: 'Eliminar usuarios seleccionados',
    deleteConfirm: '¿Está seguro que desea eliminar los usuarios seleccionados?'
  },
  button: {
    newElement: 'Nuevo Usuario'
  },
  roles: {
    ROLE_ADMIN: 'Admin',
    ROLE_BASIC: 'Básico'
  }
}
